import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { timezonesDataSource } from 'infrastructure/data-sources/timezones';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ITimezoneItem } from 'infrastructure/data-sources/timezones';

type Options = IBaseSelectBoxOption<ITimezoneItem['id'], ITimezoneItem>[];

interface ITimezoneSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {
  mainlandTimezonesOnly?: boolean;
  withAll?: boolean;
}

const TimezoneSelectBox: React.FC<ITimezoneSelectBoxProps> = (props) => {
  const { mainlandTimezonesOnly, withAll, ...otherProps } = props;
  const dataSource = useMemo(
    () => timezonesDataSource(mainlandTimezonesOnly, withAll),
    [mainlandTimezonesOnly, withAll],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...otherProps} />;
};

export default TimezoneSelectBox;
